module.exports = __webpack_public_path__ + "img/Nieuws.ed3b6b1d.svg";